module.exports = __webpack_public_path__ + "img/icon_1_31.8b4490a5.png";